'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FormNotifyMe } from './form-notify-me.component';
import { PersonaMediaCard } from './persona-media-card.component';
import { buildNotifyMeLeadPayload } from './notify-me-lead.util';
import { faceToFaceServiceId } from './consts/face-to-face-service-section.const';

import { ContentContainer } from '@/components/ui/content-container.component';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaceToFaceServiceSection = () => {
  const analytics = getAnalyticsPlugin();

  return (
    <section id={faceToFaceServiceId} data-testid={DataTestIdEnum.CITY_FACE_TO_FACE_SERVICE_SECTION}>
      <ContentContainer className="bg-white md:bg-transparent py-6 md:py-0 my-0 md:my-10">
        <div className="flex gap-6">
          <FormNotifyMe
            className="w-full xl:w-3/5"
            onSubmitCallback={(data) => {
              analytics.track(
                AnalyticsEnum.CLICK_LEAD_PRESENTIAL_SERVICE,
                buildNotifyMeLeadPayload(data),
              );
            }}
          />

          <PersonaMediaCard className="hidden xl:flex w-2/5" priority />
        </div>
      </ContentContainer>
    </section>
  );
};
